// Portrait.tsx
import React from "react";

type Props = {
    index?: number;
    row?: number;
    col?: number;
    rows?: number; // default 10
    cols?: number; // default 6
    size?: number | string; // default 120
    alt?: string;
    className?: string;
};

const Portrait = ({
                      index,
                      row,
                      col,
                      rows = 4,
                      cols = 8,
                      size = 230,
                      alt = "portrait",
                      className,
                  }: Props) => {
    const r = row ?? (index !== undefined ? Math.floor(index / cols) : 0);
    const c = col ?? (index !== undefined ? index % cols : 0);

    const bgPosX = (c / (cols - 1)) * 100;
    const bgPosY = (r / (rows - 1)) * 100 + (4 - 3 * r);
    const side = typeof size === "number" ? `${size}px` : size;

    return (
        <div
            role="img"
            aria-label={alt}
            className={className}
            style={{
                width: side,
                height: side,
                // backgroundImage: `url(/portraits-sprite.webp)`, // 👈 direct path from public
                backgroundImage: `url(/portraits.webp)`, // 👈 direct path from public
                backgroundRepeat: "no-repeat",
                backgroundSize: `${cols * 100}% ${rows * 100}%`,
                backgroundPosition: `${bgPosX}% ${bgPosY}%`,
                borderRadius: "12px",
            }}
        />
    );
}

export default Portrait;